import { render, staticRenderFns } from "./ArticleContentList.vue?vue&type=template&id=891738c4&scoped=true&"
import script from "./ArticleContentList.vue?vue&type=script&lang=js&"
export * from "./ArticleContentList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContentList.vue?vue&type=style&index=0&id=891738c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891738c4",
  null
  
)

export default component.exports